/**
 * This constants of labels is used in the popup component.
 */
export const LegalModal = {
    btnTitle: 'Ir al sitio',
    labels1: {
        audi: 'Volkswagen de México, S.A. de C.V. marca Audi te informa que la única página oficial de la marca comercial Audi es: www.audi.com.mx, por lo que en ella encontrarás la información de nuevos modelos, servicios, planes financieros, accesorios y promociones de autos nuevos de la marca.',
        default: 'Estas a punto de salir de',
    },
    labels2: {
        audi: 'Estás saliendo del sitio web oficial de Volkswagen de México, S.A. de C.V. marca Audi para entrar a un sitio web propiedad de Volkswagen Leasing, S.A. de C.V. Este sitio, así como la totalidad de su contenido, no pertenece a Volkswagen de México, S.A. de C.V. marca Audi.',
        default: 'Todo proceso fuera de esta página no es responsabilidad de {brand} México.',
    }
};
